/* ComfyHug: nieve suave cayendo (ambiente navideño).
 * La activa la sección "MT - Christmas effects" con [data-mt-nieve].
 * Respeta "reducir movimiento" y se pausa con la pestaña oculta.
 */
(function () {
  function initNieve() {
    var ajustes = document.querySelector('[data-mt-nieve]');
    if (!ajustes || document.querySelector('.mt-nieve')) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var cantidad = parseInt(ajustes.getAttribute('data-cantidad') || '45', 10);
    if (document.documentElement.clientWidth < 750) cantidad = Math.round(cantidad * 0.55);

    var lienzo = document.createElement('canvas');
    lienzo.className = 'mt-nieve';
    lienzo.setAttribute('aria-hidden', 'true');
    document.body.appendChild(lienzo);

    var ctx = lienzo.getContext('2d');
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var ancho = 0;
    var alto = 0;
    var copos = [];

    function medir() {
      // clientWidth (sin la barra de desplazamiento) para no crear scroll horizontal
      ancho = document.documentElement.clientWidth;
      alto = window.innerHeight;
      lienzo.width = ancho * dpr;
      lienzo.height = alto * dpr;
      lienzo.style.width = '100%';
      lienzo.style.height = '100%';
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }

    medir();
    window.addEventListener('resize', medir);

    // Copos de nieve de 6 brazos, dibujados una vez en pequeños lienzos (sprites) y luego
    // solo copiados y girados en cada fotograma, para que la animación sea ligera.
    var TAM = 64;
    function crearSprite(tipo) {
      var s = document.createElement('canvas');
      s.width = s.height = TAM;
      var c = s.getContext('2d');
      var r = TAM / 2 - 5;
      c.translate(TAM / 2, TAM / 2);
      c.lineCap = 'round';
      function trazos() {
        for (var k = 0; k < 6; k++) {
          c.save();
          c.rotate((Math.PI / 3) * k);
          c.beginPath();
          c.moveTo(0, 0);
          c.lineTo(0, -r);
          if (tipo === 0) {
            c.moveTo(0, -r * 0.5); c.lineTo(-r * 0.24, -r * 0.72);
            c.moveTo(0, -r * 0.5); c.lineTo(r * 0.24, -r * 0.72);
          } else if (tipo === 1) {
            c.moveTo(0, -r * 0.35); c.lineTo(-r * 0.2, -r * 0.5);
            c.moveTo(0, -r * 0.35); c.lineTo(r * 0.2, -r * 0.5);
            c.moveTo(0, -r * 0.65); c.lineTo(-r * 0.18, -r * 0.82);
            c.moveTo(0, -r * 0.65); c.lineTo(r * 0.18, -r * 0.82);
          } else {
            c.moveTo(-r * 0.22, -r * 0.62); c.lineTo(r * 0.22, -r * 0.62);
          }
          c.stroke();
          c.restore();
        }
      }
      // Contorno gris azulado debajo para que el copo blanco se vea sobre el fondo crema
      c.strokeStyle = 'rgba(105, 130, 150, 0.55)';
      c.lineWidth = 6;
      trazos();
      c.strokeStyle = '#ffffff';
      c.lineWidth = 3;
      trazos();
      c.beginPath();
      c.arc(0, 0, 3, 0, Math.PI * 2);
      c.fillStyle = '#ffffff';
      c.fill();
      return s;
    }
    var sprites = [crearSprite(0), crearSprite(1), crearSprite(2)];

    for (var i = 0; i < cantidad; i++) {
      copos.push({
        x: Math.random() * ancho,
        y: Math.random() * alto,
        tam: 9 + Math.random() * 13,
        v: 0.3 + Math.random() * 0.7,
        fase: Math.random() * Math.PI * 2,
        giro: Math.random() * Math.PI,
        vgiro: (Math.random() - 0.5) * 0.02,
        a: 0.6 + Math.random() * 0.4,
        sprite: sprites[i % sprites.length]
      });
    }

    function dibujar() {
      if (!document.hidden) {
        ctx.clearRect(0, 0, ancho, alto);
        for (var j = 0; j < copos.length; j++) {
          var c = copos[j];
          c.y += c.v;
          c.fase += 0.012;
          c.giro += c.vgiro;
          c.x += Math.sin(c.fase) * 0.35;
          if (c.y > alto + c.tam) {
            c.y = -c.tam;
            c.x = Math.random() * ancho;
          }
          ctx.save();
          ctx.globalAlpha = c.a;
          ctx.translate(c.x, c.y);
          ctx.rotate(c.giro);
          ctx.drawImage(c.sprite, -c.tam / 2, -c.tam / 2, c.tam, c.tam);
          ctx.restore();
        }
      }
      window.requestAnimationFrame(dibujar);
    }

    window.requestAnimationFrame(dibujar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initNieve);
  } else {
    initNieve();
  }
})();
